import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './context-menu.styles'
import DropMenu from 'pobble-components/dist/drop-menu'
import MoreButton from 'pobble-components/dist/more-button'
import FileIcon from 'react-icons/lib/fa/file-text-o'

const ContextMenu = ({ classes, onGoToWork }) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <Fragment>
          <MenuItem
            onClick={() => {
              onGoToWork()
              closePopover()
            }}>
            <IconHolder>
              <FileIcon />
            </IconHolder>
            View work
          </MenuItem>
        </Fragment>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
